import React from 'react';
import { Star, Quote } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    id: 1,
    name: 'Jamie Wilson',
    role: 'Small Business Owner',
    content: "These stickers have been a game-changer for my brand! The quality is outstanding and my customers love them. I've reordered multiple times.",
    rating: 5,
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&q=80'
  }, {
    id: 2,
    name: 'Michael Chen',
    role: 'Graphic Designer',
    content: "As a designer, I'm extremely picky about print quality. StickerJoy exceeded my expectations - vibrant colors, perfect cuts, and fast delivery!",
    rating: 5,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&q=80'
  }, {
    id: 3,
    name: 'Sophia Rodriguez',
    role: 'Event Planner',
    content: 'I ordered custom stickers for a corporate event with a tight deadline. Not only did they arrive on time, but they looked amazing. Will definitely use again!',
    rating: 4,
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&q=80'
  }];
  return <section className="bg-white py-16" data-id="element-249">
      <div className="container mx-auto px-4" data-id="element-250">
        <div className="text-center mb-12" data-id="element-251">
          <span className="text-[#ff6b6b] font-medium" data-id="element-252">Testimonials</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2 mb-4" data-id="element-253">
            Happy Customers
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-254">
            Don't just take our word for it – see what our customers have to say
            about their StickerJoy experience.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-255">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 shadow-lg relative" data-id="element-256">
              <div className="absolute -top-3 -left-3" data-id="element-257">
                <div className="bg-[#00b8c4] rounded-full p-2 shadow-md" data-id="element-258">
                  <Quote className="h-5 w-5 text-white" data-id="element-259" />
                </div>
              </div>
              <div className="mb-6 pt-4" data-id="element-260">
                <div className="flex mb-4" data-id="element-261">
                  {[...Array(5)].map((_, i) => <Star key={i} className={`h-5 w-5 ${i < testimonial.rating ? 'text-[#ffcc29] fill-[#ffcc29]' : 'text-gray-300'}`} data-id="element-262" />)}
                </div>
                <p className="text-gray-700 italic" data-id="element-263">"{testimonial.content}"</p>
              </div>
              <div className="flex items-center" data-id="element-264">
                <img src={testimonial.image} alt={testimonial.name} className="h-12 w-12 rounded-full object-cover border-2 border-[#ff6b6b]" data-id="element-265" />
                <div className="ml-3" data-id="element-266">
                  <h4 className="font-bold text-gray-800" data-id="element-267">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-500" data-id="element-268">{testimonial.role}</p>
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-16 text-center" data-id="element-269">
          <div className="inline-block bg-[#ffcc29] rounded-xl px-8 py-6 shadow-lg transform transition-transform hover:scale-105" data-id="element-270">
            <p className="text-xl md:text-2xl font-bold text-gray-800" data-id="element-271">
              Join over 10,000 happy customers creating amazing stickers!
            </p>
          </div>
        </div>
      </div>
    </section>;
};